// extracted by mini-css-extract-plugin
module.exports = {"container":"WizardHeader_container__XPGCY","title":"WizardHeader_title__Rj2CH","intro":"WizardHeader_intro__8_sQI"};